(w => {
    const assetId = 'fbpixel-search';

    if (!w.umwAssets || !w.umwAssets[assetId] || !w.umwAssets[assetId].length) {
        console.error('No context found for ' + assetId);
        return;
    }

    const evtSearch = w.umwAssets[assetId][0];

    w.fbq('track', 'Search', {
        search_string: evtSearch.searchTerm,
        content_ids: evtSearch.foundProdIds,
        content_type: 'product'
    });
        
})(window);